<sn-message-scroll *ngIf="!isLoading; else spinner" [fetchFn]="fetchMessages">
  <mat-spinner
    *ngIf="isFetching"
    class="message-list__spinner"
    [diameter]="48"
    [strokeWidth]="4"
    color="accent"
  ></mat-spinner>

  <sn-message-typing [typingMembers]="typingMembers"></sn-message-typing>

  <div class="no-messages" *ngIf="!channel.messages.length">
    <br />
    {{ 'map.tools.chatDrawer.noMessagesYet' | t }}
  </div>

  <ng-container *ngFor="let message of channel.messages; trackBy: trackMessage; let index = index">
    <div
      *ngIf="
        (message.twilio.author === 'system' && !channel.hideSystemNotifications) ||
        message.twilio.author !== 'system'
      "
    >
      <div class="day-beginning" *ngIf="isMessageFirstInDay(index)">
        <mat-divider></mat-divider>
        <b class="day-beginning-date" *ngIf="isToday(message.twilio.dateCreated)">{{ 'common.today' | t }}</b>
        <b class="day-beginning-date" *ngIf="!isToday(message.twilio.dateCreated)">{{
          message.twilio.dateCreated | fsFormatDate : 'mediumDate'
        }}</b>
        <mat-divider></mat-divider>
      </div>
      <sn-message-item
        [message]="message"
        [channel]="channel"
        [author]="getMessageAuthor(message.twilio.author)"
        [inherited]="isMessageInherited(index)"
      >
      </sn-message-item>
    </div>
  </ng-container>
</sn-message-scroll>

<ng-template #spinner>
  <mat-spinner
    class="message-list__spinner"
    [diameter]="48"
    [strokeWidth]="4"
    color="accent"
  ></mat-spinner>
</ng-template>
